export enum MarkdownTestIdEnum {
  MARKDOWN_CONTAINER = 'markdown--container',
  MARKDOWN_CONTENT = 'markdown--content',
}
